/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiNameCardinalitiesByAccountRequest,
    InternalApiNameCardinalitiesByAccountRequestFromJSON,
    InternalApiNameCardinalitiesByAccountRequestToJSON,
    InternalApiNameCardinalitiesByAccountResponse,
    InternalApiNameCardinalitiesByAccountResponseFromJSON,
    InternalApiNameCardinalitiesByAccountResponseToJSON,
    InternalApiSortDirection,
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionToJSON,
    InternalApiTransaction,
    InternalApiTransactionFromJSON,
    InternalApiTransactionToJSON,
    InternalApiTransactionByIdsQuery,
    InternalApiTransactionByIdsQueryFromJSON,
    InternalApiTransactionByIdsQueryToJSON,
    InternalApiTransactionExportQuery,
    InternalApiTransactionExportQueryFromJSON,
    InternalApiTransactionExportQueryToJSON,
    InternalApiTransactionSearchQuery,
    InternalApiTransactionSearchQueryFromJSON,
    InternalApiTransactionSearchQueryToJSON,
    InternalApiTransactionsPage,
    InternalApiTransactionsPageFromJSON,
    InternalApiTransactionsPageToJSON,
} from '../models';

export interface ExportTransactionsRequest {
    internalApiTransactionExportQuery: InternalApiTransactionExportQuery;
}

export interface FindAllPersonTransactionsRequest {
    personId: string;
    page: number;
    size: number;
    query?: string;
    orderBy?: string;
    direction?: InternalApiSortDirection;
}

export interface FindAllTransactionsInternalRequest {
    internalApiTransactionSearchQuery: InternalApiTransactionSearchQuery;
}

export interface FindTransactionByIdRequest {
    transactionId: string;
}

export interface FindTransactionByIdsInternalRequest {
    internalApiTransactionByIdsQuery: InternalApiTransactionByIdsQuery;
}

export interface GetNameCardinalitiesByAccountRequest {
    internalApiNameCardinalitiesByAccountRequest: InternalApiNameCardinalitiesByAccountRequest;
}

/**
 * 
 */
export class TransactionInternalApi extends runtime.BaseAPI {

    /**
     * Check if any Transactions exist
     */
    async checkIfTransactionsExistRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/transactions/exist`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Check if any Transactions exist
     */
    async checkIfTransactionsExist(initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.checkIfTransactionsExistRaw(initOverrides);
        return await response.value();
    }

    /**
     * Export transactions
     */
    async exportTransactionsRaw(requestParameters: ExportTransactionsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiTransactionExportQuery === null || requestParameters.internalApiTransactionExportQuery === undefined) {
            throw new runtime.RequiredError('internalApiTransactionExportQuery','Required parameter requestParameters.internalApiTransactionExportQuery was null or undefined when calling exportTransactions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/transactions/export`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiTransactionExportQueryToJSON(requestParameters.internalApiTransactionExportQuery),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Export transactions
     */
    async exportTransactions(requestParameters: ExportTransactionsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.exportTransactionsRaw(requestParameters, initOverrides);
    }

    /**
     * NB! If there are more than 10000 results then the API shows the number of total results as 10000 and you can\'t paginate past the 10000th result.
     * Fetch all person transactions
     */
    async findAllPersonTransactionsRaw(requestParameters: FindAllPersonTransactionsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiTransactionsPage>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling findAllPersonTransactions.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllPersonTransactions.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllPersonTransactions.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/transactions`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiTransactionsPageFromJSON(jsonValue));
    }

    /**
     * NB! If there are more than 10000 results then the API shows the number of total results as 10000 and you can\'t paginate past the 10000th result.
     * Fetch all person transactions
     */
    async findAllPersonTransactions(requestParameters: FindAllPersonTransactionsRequest, initOverrides?: RequestInit): Promise<InternalApiTransactionsPage> {
        const response = await this.findAllPersonTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch all transactions
     */
    async findAllTransactionsInternalRaw(requestParameters: FindAllTransactionsInternalRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiTransactionsPage>> {
        if (requestParameters.internalApiTransactionSearchQuery === null || requestParameters.internalApiTransactionSearchQuery === undefined) {
            throw new runtime.RequiredError('internalApiTransactionSearchQuery','Required parameter requestParameters.internalApiTransactionSearchQuery was null or undefined when calling findAllTransactionsInternal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/transactions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiTransactionSearchQueryToJSON(requestParameters.internalApiTransactionSearchQuery),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiTransactionsPageFromJSON(jsonValue));
    }

    /**
     * Fetch all transactions
     */
    async findAllTransactionsInternal(requestParameters: FindAllTransactionsInternalRequest, initOverrides?: RequestInit): Promise<InternalApiTransactionsPage> {
        const response = await this.findAllTransactionsInternalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches transaction by id
     */
    async findTransactionByIdRaw(requestParameters: FindTransactionByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiTransaction>> {
        if (requestParameters.transactionId === null || requestParameters.transactionId === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling findTransactionById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/transactions/{transactionId}`.replace(`{${"transactionId"}}`, encodeURIComponent(String(requestParameters.transactionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiTransactionFromJSON(jsonValue));
    }

    /**
     * Fetches transaction by id
     */
    async findTransactionById(requestParameters: FindTransactionByIdRequest, initOverrides?: RequestInit): Promise<InternalApiTransaction> {
        const response = await this.findTransactionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch all transactions by ids
     */
    async findTransactionByIdsInternalRaw(requestParameters: FindTransactionByIdsInternalRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiTransactionsPage>> {
        if (requestParameters.internalApiTransactionByIdsQuery === null || requestParameters.internalApiTransactionByIdsQuery === undefined) {
            throw new runtime.RequiredError('internalApiTransactionByIdsQuery','Required parameter requestParameters.internalApiTransactionByIdsQuery was null or undefined when calling findTransactionByIdsInternal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/transactions/byIds`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiTransactionByIdsQueryToJSON(requestParameters.internalApiTransactionByIdsQuery),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiTransactionsPageFromJSON(jsonValue));
    }

    /**
     * Fetch all transactions by ids
     */
    async findTransactionByIdsInternal(requestParameters: FindTransactionByIdsInternalRequest, initOverrides?: RequestInit): Promise<InternalApiTransactionsPage> {
        const response = await this.findTransactionByIdsInternalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Count distinct names that have received or sent funds to the included accounts
     */
    async getNameCardinalitiesByAccountRaw(requestParameters: GetNameCardinalitiesByAccountRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiNameCardinalitiesByAccountResponse>> {
        if (requestParameters.internalApiNameCardinalitiesByAccountRequest === null || requestParameters.internalApiNameCardinalitiesByAccountRequest === undefined) {
            throw new runtime.RequiredError('internalApiNameCardinalitiesByAccountRequest','Required parameter requestParameters.internalApiNameCardinalitiesByAccountRequest was null or undefined when calling getNameCardinalitiesByAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/transactions/name-cardinalities-by-account`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiNameCardinalitiesByAccountRequestToJSON(requestParameters.internalApiNameCardinalitiesByAccountRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiNameCardinalitiesByAccountResponseFromJSON(jsonValue));
    }

    /**
     * Count distinct names that have received or sent funds to the included accounts
     */
    async getNameCardinalitiesByAccount(requestParameters: GetNameCardinalitiesByAccountRequest, initOverrides?: RequestInit): Promise<InternalApiNameCardinalitiesByAccountResponse> {
        const response = await this.getNameCardinalitiesByAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
